import { IDishesState } from './dishesContext';
import { DishesActionTypes, TDishesActions } from './dishesActions';

export const dishesReducer = (state: IDishesState, action: TDishesActions): IDishesState => {
	switch (action.type) {
		case DishesActionTypes.SET_DISHES:
			return {
				...state,
				dishes: action.payload.dishes,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case DishesActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case DishesActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				IDSelectedRestaurant: null,
				IDSelectedCategory: null,
				IDSelectedSubCategory: null,
				isDisabledDish: false,
				isUnassignedDishes: false,
				currentPage: 1,
			};
		case DishesActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				IDSelectedCategory: null,
				IDSelectedSubCategory: null,
				isDisabledDish: false,
				isUnassignedDishes: false,
				currentPage: 1,
			};
		case DishesActionTypes.SET_ID_CATEGORY:
			return {
				...state,
				IDSelectedCategory: action.payload.IDSelectedCategory,
				IDSelectedSubCategory: null,
				isUnassignedDishes: false,
				currentPage: 1,
			};
		case DishesActionTypes.SET_ID_SUB_CATEGORY:
			return {
				...state,
				IDSelectedSubCategory: action.payload.IDSelectedSubCategory,
				isUnassignedDishes: false,
				currentPage: 1,
			};
		case DishesActionTypes.SET_PRICE_FROM:
			return {
				...state,
				priceFrom: action.payload.priceFrom,
				currentPage: 1,
			};
		case DishesActionTypes.SET_PRICE_TO:
			return {
				...state,
				priceTo: action.payload.priceTo,
				currentPage: 1,
			};
		case DishesActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				IDSelectedCustomer: null,
				IDSelectedRestaurant: null,
				IDSelectedCategory: null,
				IDSelectedSubCategory: null,
				priceFrom: '',
				priceTo: '',
				isUnassignedDishes: false,
				isDisabledDish: false,
				isShowOnlyComboItems: false,
				currentPage: 1,
			};
		case DishesActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case DishesActionTypes.TOGGLE_UNASSIGNED_DISHES:
			return {
				...state,
				isUnassignedDishes: !state.isUnassignedDishes,
				currentPage: 1,
			};
		case DishesActionTypes.TOGGLE_DISABLED_DISHES:
			return {
				...state,
				isDisabledDish: !state.isDisabledDish,
				currentPage: 1,
			};
		case DishesActionTypes.TOGGLE_SHOW_COMBO_ITEMS:
			return {
				...state,
				isShowOnlyComboItems: !state.isShowOnlyComboItems,
				currentPage: 1,
			};
		case DishesActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case DishesActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case DishesActionTypes.SET_DISH_ID_FOR_DELETION:
			return {
				...state,
				dishIDForDeletion: action.payload.dishIDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case DishesActionTypes.SET_DISH_ID_FOR_FULL_INFO:
			return {
				...state,
				dishIDForFullInfo: action.payload.dishIDForFullInfo,
			};
		case DishesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case DishesActionTypes.CHANGE_FULL_DISH_INFO_VISIBLE_FORM:
			return {
				...state,
				fullDishInfoVisibleForm: action.payload.fullDishInfoVisibleForm,
			};
		case DishesActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		default:
			return state;
	}
};
